import { useState, useEffect } from 'react';

export function useLocalStorageState(initialState, localStorageName) {
  const [storage, setStorage] = useState(() => {
    const storedValue = localStorage.getItem(localStorageName);
    return storedValue ? JSON.parse(storedValue) : initialState;
  });

  useEffect(
    function () {
      localStorage.setItem(localStorageName, JSON.stringify(storage));
    },
    [storage, localStorageName]
  );

  return [storage, setStorage];
}
